import React from 'react';
import {
	CircularProgress,
	ListItemIcon,
	ListItemText,
	MenuItem,
	Tooltip,
	Typography,
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

/**
 * One row of the "Generate ..." menu: the title, with `message` as its tooltip and
 * caption.
 *
 * @param {Object} props
 * @param {string} props.title
 * @param {JSX.Element} props.icon - Shown when the row is neither busy nor warning.
 * @param {string} [props.message] - Why the row is disabled, or a warning.
 * @param {boolean} [props.isBusy] - Shows a spinner in place of the icon.
 * @param {boolean} [props.showWarning] - Shows a warning icon in place of the icon.
 * @param {boolean} [props.disabled]
 * @param {Function} props.onClick
 * @returns {JSX.Element}
 */
const GenerateMenuItemRow = ({ title, icon, message, isBusy, showWarning, disabled, onClick }) => (
	<Tooltip title={message} placement='left'>
		<span>
			<MenuItem disabled={disabled} onClick={onClick}>
				<ListItemIcon>
					{isBusy ? (
						<CircularProgress size='1em' />
					) : showWarning ? (
						<ErrorOutlineIcon fontSize='small' color='warning' />
					) : (
						icon
					)}
				</ListItemIcon>
				<ListItemText
					primary={title}
					{...(message && {
						secondary: (
							<Typography variant='caption' color='text.secondary'>
								{message}
							</Typography>
						),
					})}
				/>
			</MenuItem>
		</span>
	</Tooltip>
);
GenerateMenuItemRow.displayName = 'GenerateMenuItemRow';
export default GenerateMenuItemRow;
